"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const IconButton_1 = __importDefault(require("components/shared/Button/IconButton"));
require("./PaginationModule.scss");
const PaginationModule = ({ loading = false, pageNumber = 1, handleNext = () => null, handlePrev = () => null, hasMore = true, handleFirst = () => null, handleLast = () => null, withFirstLastPage = false }) => {
    return (react_1.default.createElement("div", { className: "pagination-container" },
        withFirstLastPage && (react_1.default.createElement(IconButton_1.default, { customClass: "mr-8", isSecondary: true, onClick: () => handleFirst(), disabled: loading || pageNumber == 1 },
            react_1.default.createElement("i", { className: "material-icons" }, "first_page"))),
        react_1.default.createElement("span", { className: "mr-[16px]" },
            (0, HelperUtils_1.getObjectiveLocale)('Page'),
            " ",
            pageNumber),
        react_1.default.createElement(IconButton_1.default, { customClass: "mr-[8px]", isSecondary: true, onClick: () => handlePrev(), disabled: loading || pageNumber == 1 },
            react_1.default.createElement("i", { className: "material-icons" }, "chevron_left")),
        react_1.default.createElement(IconButton_1.default, { isSecondary: true, onClick: () => handleNext(), disabled: loading || !hasMore },
            react_1.default.createElement("i", { className: "material-icons" }, "chevron_right")),
        withFirstLastPage && (react_1.default.createElement(IconButton_1.default, { isSecondary: true, onClick: () => handleLast(), disabled: loading || !hasMore },
            react_1.default.createElement("i", { className: "material-icons" }, "last_page")))));
};
exports.default = PaginationModule;
